"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.Svg = void 0;
var react_1 = __importDefault(require("react"));
var ElementTag_1 = __importDefault(require("../internal/ElementTag"));
var Svg = function (props) {
    var _a = props.as, as = _a === void 0 ? 'svg' : _a, className = props.className, title = props.title, _b = props.role, role = _b === void 0 ? 'img' : _b, description = props.description, children = props.children, rest = __rest(props, ["as", "className", "title", "role", "description", "children"]);
    var ariaLabel = [title, description].filter(Boolean).join(' ');
    var ariaRole = role;
    if (ariaLabel.length <= 0) {
        ariaRole = undefined;
        rest['aria-hidden'] = true;
    }
    else {
        rest['aria-label'] = ariaLabel;
    }
    return (react_1["default"].createElement(ElementTag_1["default"], __assign({ as: as, role: ariaRole, className: ['svg', className] }, rest),
        title && react_1["default"].createElement("title", null, title),
        description && react_1["default"].createElement("desc", null, description),
        children));
};
exports.Svg = Svg;
//# sourceMappingURL=Svg.js.map